module.exports = __webpack_public_path__ + "img/img1.41a06078.png";